import { useContext, useEffect } from "react";
import { ApplicationStateContext, Feature } from "src/states/ApplicationState";
import { FRPContext, FRPProject, getMyAccessRights, initialize, selectProject } from "./FRPState";
import { SessionContext } from "@viamap/viamap2-common";
import { useMitStorage } from "src/managers/UseMitStorage";
import { SettingsManager } from "@viamap/viamap2-common";
import { Localization } from "@viamap/viamap2-common";

type FRPProjectSelectProps = {
   title: string;
   onSelect: (value: string) => void;
   className?: string;
};

export function FRPProjectSelect({ title, onSelect, className }: FRPProjectSelectProps) {
   const { state: frpState, dispatch: frpDispatch } = useContext(FRPContext);
   const { state: sessionState } = useContext(SessionContext);
   const { hasAccessToFeature } = useContext(ApplicationStateContext);

   const [lastUsedProjectId, setLastUsedProjectId] = useMitStorage<string | undefined>("FRP_LastProjectId", undefined);

   useEffect(() => {
      if (!frpState.isInitialized) {
         frpDispatch(initialize(SettingsManager.getSystemSetting("frp.projectsElasticIndex", ""), sessionState.userName));
      }
      let myProjects = frpState.availableProjectsList.filter(filterProjectsByAccessRights);
      if (!frpState.selectedProjectId && lastUsedProjectId && myProjects.length && myProjects.find((a) => a.id == lastUsedProjectId)) {
         frpDispatch(selectProject(lastUsedProjectId));
      }
   }, []);

   useEffect(() => {
      let myProjects = frpState.availableProjectsList.filter(filterProjectsByAccessRights);
      if (!frpState.selectedProjectId && myProjects && myProjects.length > 0) {
         if (myProjects?.length == 1) {
            frpDispatch(selectProject(myProjects[0].id));
         } else if (lastUsedProjectId && myProjects.find((a) => a.id == lastUsedProjectId)) {
            frpDispatch(selectProject(lastUsedProjectId));
         }
      }
   }, [frpState.availableProjectsList]);

   function filterProjectsByAccessRights(project: FRPProject): boolean {
      let accessRights = getMyAccessRights(project, sessionState.userRef, sessionState.customerRef);
      let result = hasAccessToFeature(Feature.FRPTool) && accessRights && accessRights.length > 0;
      return Boolean(result);
   }

   const availableProjects = (frpState.availableProjectsList || []).filter(filterProjectsByAccessRights).toSorted((a, b) => (a.name || "").localeCompare(b.name || ""));
   const selectedProjectName = frpState.selectedProjectId
      ? availableProjects.find((p) => p.id === frpState.selectedProjectId)?.name || frpState.selectedProjectId
      : Localization.getText("Vælg project");

   return (
      <div className={["FRP_Projselect", className].filter(Boolean).join(" ")}>
         <span className="FRP_Projselect__value" title={selectedProjectName}>
            {selectedProjectName}
         </span>
         <select
            className="FRP_Projselect__input"
            onChange={e => {
               let id = e.target.value;
               setLastUsedProjectId(id);
               onSelect(id);
            }}
            value={frpState.selectedProjectId || ""}
            aria-label={title}
         >
            {frpState.selectedProjectId ? null : <option key={"default"} value={""}>{Localization.getText("Vælg project")}</option>}
            {availableProjects.map((p: FRPProject) => (
               <option key={p.id} value={p.id}>{p.name}</option>
            ))}
         </select>
      </div>
   );
}

